import { get } from 'utils/fetch';
export const getAuthChallenge = async (
  publicAddress: string
): Promise<string> => {
  const challenge = await get(
    `/functions/auth-challenge?publicAddress=${publicAddress}`
  );
  return challenge.challenge;
};
